import React, {useState, useEffect, useRef, useCallback }        from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {useActionModal}                     from "components/Covers/confirmAction";
import {useInfoMsgModal}                    from "components/Covers/infoMessageModal";
import {useToastMessage}                    from "components/Covers/toastMessage";
import {InputGeneral}                       from "components/Field/field";
import {BtnCloseAction}                     from "components/Buttons/Close/BtnClose";
import MainStyle                            from "components/UI/main.module.scss";
import { 
    getQuestionTypes,
    getQuestionLists,
    getQuestionByID,
    updateQuestion,
    deleteQuestion,
    getOptionLists,
    getQuestionUsers,
    insertQuestionUser,
    removeQuestionUser
}                                           from "./questionService";
// BEGIN AG AGRID
import {AgGridReact}                        from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';
import { q3x_FunData, 
         getImgSrc,
         DavidCopperfield,
         Heimdall,
         GetLabel,
         GetAppLang,
         SetLastFeature}                    from "Utilities/utils";
import { DatePicker,
         DateTimePicker,
         DateToIsoString,
         DateFromIsoString,
         InitDateToIsoString,
         InitDateFromIsoString,
         FinDateToIsoString,
         FinDateFromIsoString,
         setDefaultInitDate,
         setDefaultFinalDate,
         compareInitFinDate }               from "components/Date/date";
import dayjs                                from "dayjs";
import { Select }                           from "antd";
import { DefaultLoadingLogo  }              from "Utilities/utils";
import { useFilter }                        from "components/Menu/menu";
import {DisplayGridDatetime}                from "components/Date/date";
import { useNavigate }                      from "react-router-dom";

let blank_question_obj = {
    QUESTION_ID:        0,
    QUESTION_TYPE_ID:   0,
    QUESTION_DESC:      "",
    STATUS_ID:          1,
    OPTION_LIST_ID:     0,
    LANG_PT:            "N",
    LANG_EN:            "N",
    LANG_ES:            "N",
    LANG_PT_DESC:       "",
    LANG_EN_DESC:       "",
    LANG_ES_DESC:       ""
};
let blank_question_users_obj = {
    QUESTION_ID         :  0 ,
    QUESTION_USERS_LIST : [] ,
    USERS_LIST          : []
};
let blank_user_obj = {
    USER_ID                 : 0,
    FULL_NAME               : "",
    COMPANY_POSITION_DESC   : "",
    SECTOR_DESC             : "",
    FILE_DATA               : ""
};
let blank_search_param_obj = {
    QUESTION_TYPES    : [1,2,3,4,5,6],
    QUESTION_STATUS   : [1,6],
    REQ_PT            : 'Y',
    REQ_EN            : 'Y',
    REQ_ES            : 'Y',
    DT_INIT           : DateToIsoString(DateFromIsoString('1970-01-01 00:00:00')),
    DT_FN             : DateToIsoString(DateFromIsoString('2050-12-31 23:59:59')),
};
let appLang = null;

const DropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};
//  #region UI Helppers
const DivisionBlock = () => {
    return(
        <>
            <div className={[MainStyle.py_2].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_1}/>
                    <div className={[MainStyle.col_lg_10, MainStyle.border_bottom].join(" ")}/>
                    <div className={MainStyle.col_lg_1}/>
                </div>
            </div>
        </>
    );
};
const DefaultPadding = () =>{
    return(
        <>
            <div className={MainStyle.py_3}/>
        </>
    );
}
const Avatar = () => {
    return (
        <svg viewBox="0 -5 66 66" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: '#f0f0f0', width: '100%', height: '100%'}}>
            <circle className={MainStyle.avatar_head} cx="32" cy="22" r="12" fill="#707070"/>
            <path d="M32 36c-9 0-20 6-20 14v14h40V50c0-8-11-14-20-14z" fill="#707070"/>
            <ellipse className={MainStyle.avatar_eye_left} cx="27" cy="20" rx="2" ry="2" fill="#fff"/>
            <ellipse className={MainStyle.avatar_eye_right} cx="37" cy="20" rx="2" ry="2" fill="#fff"/>
        </svg>
    );
};
// #endregion



// #region Filter Data
const FilterBtnRemoveItem = React.memo(({clickAction}) => {
    return (
        <div 
            onClick={clickAction}
            className={[MainStyle.py_1].join(" ")}
        >
            <div className={[MainStyle.d_flex].join(" ")}>
                <svg
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 384 512"
                    style={{width: '0.8rem', height: '0.8rem'}}
                    className={[MainStyle.close_icon].join(" ")} 
                >
                    <path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/>
                </svg>
            </div>
        </div>
    );
});
const FilterStatusList = React.memo(({...other}) => {
    const { statusList,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = statusList.find((status) => status.value === d);
        return found ? found.label : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.QUESTION_STATUS.filter(item => item !== d);
            return {
                ...prevState,
                QUESTION_STATUS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, statusList]);
    return (
        <>                                        
            {searchParam?.QUESTION_STATUS?.map((status, i) => {
                    return (
                        <div key={`question_status_list_${status}${i}`} className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(status)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(status)}
                                </span>
                            </div>
                        </div>
                    )
                }
            )}
        </>
    );
});
const FilterQuestionTypeList = React.memo(({...other}) => {
    const { questionTypeList,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = questionTypeList?.find((item) => item.QUESTION_TYPE_ID === d);
        return found ? found.QUESTION_TYPE_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.QUESTION_TYPES.filter(item => item !== d);
            return {
                ...prevState,
                QUESTION_TYPES: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, questionTypeList, setSearchParam]);

    return (
        <>                                        
            {searchParam?.QUESTION_TYPES?.map((item, i) => {
                    return (
                        <div key={`users_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                        
                    )
                }
            )}
        </>
    );
});
const FilterOptions = React.memo(({...props}) => {
    const { setRowData,
            searchMetaParam,
            searchParam,
            setSearchParam,
            questionTypeList    } = props;
    const { showInfoMessage     } = useInfoMsgModal();
    const { showLoader,
            hideLoader          } = useLoader();

    async function startSearch() {
        if (!compareInitFinDate(searchParam.DT_INIT, searchParam.DT_FN)) {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 230)});
            return;
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: "Aguarde carregando..."});
        let data = await getQuestionLists(searchParam);
        if (data) {
            if (data?.status?.statusCode == 0) {
                data = data.response.content;
                let arr = [];
                for(var j = 0; j < data.length; j++) {
                    arr.push(data[j]);
                }
                setRowData(arr);
                hideLoader();
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
            }
        }
    }

    useEffect(() => {

    },[searchMetaParam, searchParam]);

    const statusList                =  [{value: 1, label: GetLabel(appLang, 231)}, {value: 6, label: GetLabel(appLang, 232)}];

    
    return(
        <>
            <div className={[MainStyle.overflow_y_scroll].join(" ")}>
                {/*         Status        */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 37)}
                                            </span>                      
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 233)}
                                                listOfItems={statusList}
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam?.QUESTION_STATUS?.some((s) => s === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            QUESTION_STATUS: [...prevState.QUESTION_STATUS, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <FilterStatusList statusList={statusList} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
                {/*     Question Type      */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 234)}
                                            </span>                      
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 235)}
                                                listOfItems={
                                                    questionTypeList?.map((i) => (
                                                            {value: i.QUESTION_TYPE_ID, label: i.QUESTION_TYPE_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam?.QUESTION_TYPES.some((s) => s === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            QUESTION_TYPES: [...prevState.QUESTION_TYPES, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <FilterQuestionTypeList questionTypeList={questionTypeList} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                       
                {/*         DT Init       */}         
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={[MainStyle.m_3].join(" ")}>
                                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 236)}
                                </span>                      
                                <DatePicker
                                    value={InitDateFromIsoString(searchParam.DT_INIT)}
                                    placeholder={GetLabel(appLang, 236)}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(date) => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_INIT: InitDateToIsoString(date),
                                            });
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*         DT Fin        */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={[MainStyle.m_3].join(" ")}>
                                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 237)}
                                </span>
                                <DatePicker
                                    value={DateFromIsoString(searchParam.DT_FN)}
                                    placeholder={GetLabel(appLang, 237)}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(date) => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_FN: InitDateToIsoString(date),
                                            });
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_green, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_white,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={async () => {startSearch();}}
                        >
                            {GetLabel(appLang, 238)}
                        </button>
                    </div>
                </div>                            
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_vanilla, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_body,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={async () => {
                                setSearchParam(blank_search_param_obj);
                            }}
                        >
                            {GetLabel(appLang, 239)}
                        </button>
                    </div>
                </div>                            
            </div>
        </>
    );

});
// #endregion


const QuestionEditPanel = React.memo(({setProps, data, typeList }) => {
    const { showLoader,         hideLoader           }  = useLoader();                  // Control over the loader
    const { showInfoMessage                          }  = useInfoMsgModal();            // Modal message control 
    const { showActionMessage                        }  = useActionModal();             // Modal message + action control     
    const { showToastMessage                         }  = useToastMessage();            // Toast message display
    const [ questionObj,        setQuestionObj       ]  = useState(blank_question_obj); // Question object
    const [ optionDropDownList, setOptionDropDownList]  = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            let data = await getOptionLists();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    let tmp = [];
                    for (var i = 0; i < data.length; i++) {
                        tmp.push(
                            {
                                value : data[i].OPTION_LIST_ID, 
                                label:  data[i].OPTION_LIST_DESC
                            });
                    }                
                    setOptionDropDownList(tmp);
                }
                else {
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        };
        fetchData();
    },[]);

    function validateRecord(obj) {
        let passed = true;
        if (obj.QUESTION_DESC === ""){
            passed = false;
        }
        if (obj.QUESTION_TYPE_ID === 0) {
            passed = false;
        }
        if (obj.LANG_PT === "N" && obj.LANG_EN === "N" && obj.LANG_ES === "N") {
            passed = false;
        }
        if ((obj.QUESTION_TYPE_ID === 1) || (obj.QUESTION_TYPE_ID === 3) || (obj.QUESTION_TYPE_ID === 4) || (obj.QUESTION_TYPE_ID === 5)) {
            passed = (obj.OPTION_LIST_ID === 0) ? false : passed;
        }
        if (obj.LANG_PT === "Y" && obj.LANG_PT_DESC === "") {
            passed = false;
        }
        if (obj.LANG_EN === "Y" && obj.LANG_EN_DESC === "") {
            passed = false;
        }
        if (obj.LANG_ES === "Y" && obj.LANG_ES_DESC === "") {
            passed = false;
        }
        return (passed);
    }

    function handleLangToogle(lang, type) {
        if (type === 5) {
            if (lang === "PT") {
                handleChange({ LANG_PT: 'Y', LANG_PT_DESC: "Qual é a probabilidade de você recomendar     COLOQUE O TEXTO AQUI     a um(a) amigo(a) ou colega?"});

            } 
            else if (lang === "EN") {
                handleChange({ LANG_EN: 'Y', LANG_EN_DESC: "How likely are you to recommend     COLOQUE O TEXTO AQUI     to a friend or colleague?"});

            } 
            else {
                handleChange({ LANG_ES: 'Y', LANG_ES_DESC: "¿Qué tan probable es que recomiende     COLOQUE O TEXTO AQUI     a un(a) amigo(a) o colega?"});

            } 
        }
        else {
            if (lang === "PT") {
                handleChange({ LANG_PT: 'Y' });
            }
            else if (lang === "EN") {
                handleChange({ LANG_EN: 'Y' });
            }
            else {
                handleChange({ LANG_ES: 'Y' });
            }
        }

    }

    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_question_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };   

    const handleSave = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updateQuestion(questionObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (questionObj.QUESTION_ID === 0) {
                    setProps({ setScreen: 1, data: blank_question_obj });
                }
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deleteQuestion(questionObj.QUESTION_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_question_obj });   
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {
        const mergedValues = {
            ...questionObj,
            ...updatedValues
        };
        setQuestionObj(mergedValues);
    };

    const BtnSave = () => {
        if (validateRecord(questionObj)) {
            showActionMessage(
                { header: GetLabel(appLang, 54), message:  GetLabel(appLang, 240)},
                { confirm_action: () => handleSave()}
            );
            return;
        }
        else {
            showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 185)}<br/>{GetLabel(appLang, 186)}<br/>{GetLabel(appLang, 187)}</>});
            return;
        }
    };

    const BtnDelete = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 241) },
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (question_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getQuestionByID(question_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            setQuestionObj(fetchedData || blank_question_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setQuestionObj(blank_question_obj);
            }
        };
        if (data?.QUESTION_ID && data.QUESTION_ID !== 0) {
            fetchData(data.QUESTION_ID);
        } 
        else {
            setQuestionObj(blank_question_obj);
        }
    }, [data]);

    function QuestionTypeChange (qt) {
        if (qt === 1) {
            handleChange({ QUESTION_TYPE_ID: qt, OPTION_LIST_ID: 1 });
        }
        else if (qt === 2) {
            handleChange({ QUESTION_TYPE_ID: qt, OPTION_LIST_ID: 0 });
        }
        else if (qt === 3) {
            handleChange({ QUESTION_TYPE_ID: qt, OPTION_LIST_ID: 0 });
        }
        else if (qt === 4) {
            handleChange({ QUESTION_TYPE_ID: qt, OPTION_LIST_ID: 0 });
        }
        else if (qt === 5) {
            handleChange({ QUESTION_TYPE_ID: qt, OPTION_LIST_ID: 2 });
        }
        else {
            handleChange({ QUESTION_TYPE_ID: qt, OPTION_LIST_ID: 0 });
        }

    }
    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_5}/>
                    {/*                 Question Description           */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 242)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <InputGeneral 
                                    value={questionObj.QUESTION_DESC}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                    onChange={(event) => handleChange({ QUESTION_DESC: q3x_FunData(event.target.value) })}
                                    placeholder={GetLabel(appLang, 243)}
                                    maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{questionObj.QUESTION_DESC.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>                

                    {/*                 Question Type                  */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 244)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <DropdownList
                                    value={questionObj.QUESTION_TYPE_ID > 0 ? parseInt(questionObj.QUESTION_TYPE_ID) : null}
                                    placeholder={GetLabel(appLang, 245)}                                
                                    listOfItems={typeList.map((l) => ({value: l.QUESTION_TYPE_ID, label: l.QUESTION_TYPE_DESC}))}
                                    style={{ width: "100%" }}  
                                    className={MainStyle.antd_custom_select}                               
                                    popupClassName={MainStyle.antd_custom_select}                              
                                    onChange={(event) => {
                                        QuestionTypeChange(event === undefined ? 0 : event);
                                    }}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    {/*                 Option List                    */}
                    {
                        (questionObj.QUESTION_TYPE_ID == 3) ||  (questionObj.QUESTION_TYPE_ID == 4) ?
                            <>
                                <div className={[MainStyle.py_2].join(" ")}>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg_1}/>
                                    <div className={MainStyle.col_lg_5}>
                                        <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                            <span className={[MainStyle.fs_6,
                                                              MainStyle.text_body,
                                                              MainStyle.fw_semibold
                                                            ].join(" ")}
                                            >
                                                {GetLabel(appLang, 246)}*:
                                            </span>
                                        </div>
                                    </div>
                                    <div className={MainStyle.col_lg_5}>
                                        <div className={MainStyle.mx_3}>
                                            {
                                                optionDropDownList ?
                                                    <DropdownList   
                                                        value={questionObj.OPTION_LIST_ID > 0 ? questionObj.OPTION_LIST_ID : undefined}
                                                        placeholder={GetLabel(appLang, 247)}                                
                                                        listOfItems={optionDropDownList}
                                                        style={{ width: "100%" }}  
                                                        className={MainStyle.antd_custom_select}                               
                                                        popupClassName={MainStyle.antd_custom_select}                              
                                                        onChange={(event) => {
                                                            handleChange(
                                                                event === undefined ? 
                                                                    {OPTION_LIST_ID: 0} 
                                                                : 
                                                                    {OPTION_LIST_ID: event}
                                                            );
                                                        }}
                                                    />
                                                :
                                                
                                                    null

                                            }
                                        </div>
                                    </div>
                                    <div className={MainStyle.col_lg_1}/>
                                </div>
                            </>
                        :
                            null
                    }

                    {/*                 Division Block                 */}
                    <div className={[MainStyle.py_2].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg_1}/>
                            <div className={[MainStyle.col_lg_10, MainStyle.border_bottom].join(" ")}/>
                            <div className={MainStyle.col_lg_1}/>
                        </div>
                    </div>

                    {/*             Option List PT Lang                 */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            
                            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                                <div className={MainStyle.col_5}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 193)}: 
                                        </span>
                                    </div>
                                </div>      
                                <div className={[MainStyle.col_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 253)});}}>
                                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className={MainStyle.col_6}>
                                    <div className={MainStyle.ms_3}>
                                        <input
                                            type="checkbox"
                                            name={"read"}
                                            checked={questionObj.LANG_PT === "Y" ? true : false}
                                            onChange={()=> {questionObj.LANG_PT === "N"? handleLangToogle("PT", questionObj.QUESTION_TYPE_ID) : handleChange({ LANG_PT: 'N', LANG_PT_DESC: "" })}}
                                            style={{ transform: "scale(1.5)" }}
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                            </div>

                            {
                                questionObj.LANG_PT === "Y" ?
                                    <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                                        <div className={MainStyle.col_lg_12}>
                                            <div className={[MainStyle.mx_3, MainStyle.my_2].join(" ")}>
                                                <InputGeneral 
                                                    value={questionObj.LANG_PT_DESC}
                                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                    onChange={(event) => handleChange({ LANG_PT_DESC: q3x_FunData(event.target.value) })}
                                                    placeholder={GetLabel(appLang, 248)}
                                                    maxLength={1500}
                                                    autoSize={{ minRows: 1, maxRows: 50 }}
                                                />
                                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{questionObj.LANG_PT_DESC.length} {GetLabel(appLang, 44)} 1500 {GetLabel(appLang, 45)}.</span>
                                            </div>
                                        </div>
                                    </div>
                                        :
                                    null
                            }

                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    {/*                 Division Block                 */}
                    <div className={[MainStyle.py_2].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg_1}/>
                            <div className={[MainStyle.col_lg_10, MainStyle.border_bottom].join(" ")}/>
                            <div className={MainStyle.col_lg_1}/>
                        </div>
                    </div>

                    {/*             Option List EN Lang                 */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            
                            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                                <div className={MainStyle.col_5}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 194)}: 
                                        </span>
                                    </div>
                                </div>      
                                <div className={[MainStyle.col_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 254)});}}>
                                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className={MainStyle.col_6}>
                                    <div className={MainStyle.ms_3}>
                                        <input
                                            type="checkbox"
                                            name={"read"}
                                            checked={questionObj.LANG_EN === "Y" ? true : false}
                                            onChange={()=> {questionObj.LANG_EN === "N"? handleLangToogle("EN", questionObj.QUESTION_TYPE_ID) : handleChange({ LANG_EN: 'N', LANG_EN_DESC: "" })}}
                                            style={{ transform: "scale(1.5)" }}
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                            </div>
                            {
                                questionObj.LANG_EN === "Y" ?
                                    <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                                        <div className={MainStyle.col_lg_12}>
                                            <div className={[MainStyle.mx_3, MainStyle.my_2].join(" ")}>
                                                <InputGeneral 
                                                    value={questionObj.LANG_EN_DESC}
                                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                    onChange={(event) => handleChange({ LANG_EN_DESC: q3x_FunData(event.target.value) })}
                                                    placeholder={GetLabel(appLang, 248)}
                                                    maxLength={1500}
                                                    autoSize={{ minRows: 1, maxRows: 50 }}
                                                />
                                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{questionObj.LANG_EN_DESC.length} {GetLabel(appLang, 44)} 1500 {GetLabel(appLang, 45)}.</span>
                                            </div>
                                        </div>
                                    </div>
                                        :
                                    null
                            }                            

                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    {/*                 Division Block                 */}
                    <div className={[MainStyle.py_2].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg_1}/>
                            <div className={[MainStyle.col_lg_10, MainStyle.border_bottom].join(" ")}/>
                            <div className={MainStyle.col_lg_1}/>
                        </div>
                    </div>

                    {/*             Option List ES Lang                 */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            
                            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                                <div className={MainStyle.col_5}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 195)}: 
                                        </span>
                                    </div>
                                </div>      
                                <div className={[MainStyle.col_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 255)});}}>
                                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className={MainStyle.col_6}>
                                    <div className={MainStyle.ms_3}>
                                        <input
                                            type="checkbox"
                                            name={"read"}
                                            checked={questionObj.LANG_ES === "Y" ? true : false}
                                            onChange={()=> {questionObj.LANG_ES === "N"? handleLangToogle("ES", questionObj.QUESTION_TYPE_ID) : handleChange({ LANG_ES: 'N', LANG_ES_DESC: "" })}}
                                            style={{ transform: "scale(1.5)" }}
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                            </div>
                            {
                                questionObj.LANG_ES === "Y" ?
                                    <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                                        <div className={MainStyle.col_lg_12}>
                                            <div className={[MainStyle.mx_3, MainStyle.my_2].join(" ")}>
                                                <InputGeneral 
                                                    value={questionObj.LANG_ES_DESC}
                                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                    onChange={(event) => handleChange({ LANG_ES_DESC: q3x_FunData(event.target.value) })}
                                                    placeholder={GetLabel(appLang, 248)}
                                                    maxLength={1500}
                                                    autoSize={{ minRows: 1, maxRows: 50 }}
                                                />
                                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{questionObj.LANG_ES_DESC.length} {GetLabel(appLang, 44)} 1500 {GetLabel(appLang, 45)}.</span>
                                            </div>
                                        </div>
                                    </div>
                                        :
                                    null
                            }                            

                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    <div className={MainStyle.py_3}/>
                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(9,89,6) && (
                        questionObj.QUESTION_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {BtnDelete()}}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(9,89,4) && (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={BtnSave}
                            >
                                {GetLabel(appLang, 49)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}                                    
        </>
    );

});

const SelectDataPopup = ({displayModal, setDisplayModal, objectSet, mainDataset, dataset}) => {
    const { showLoader,  hideLoader     }  = useLoader();         // Control over the loader
    const { showInfoMessage             }  = useInfoMsgModal();   // Modal message control     
    const { showToastMessage            }  = useToastMessage();   // Toast message display
    const [searchString, setSearchString] = useState("");
    const [filteredData, setFilteredData] = useState(dataset);

    const handleSelect = async (user_id, full_name, position_desc, sector_desc, file_data) => {
        if (mainDataset.QUESTION_USERS_LIST.some((u) => u.USER_ID === user_id)) {
            showToastMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 218)});
            return;
        }

        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await insertQuestionUser(mainDataset.QUESTION_ID, user_id);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                
                //  Handle the object state
                const newObject = {
                    ...blank_user_obj,
                    USER_ID:   user_id,
                    FULL_NAME: full_name,
                    COMPANY_POSITION_DESC: position_desc,
                    SECTOR_DESC: sector_desc,
                    FILE_DATA: file_data,
                };
    
                const newList = [...mainDataset.QUESTION_USERS_LIST, newObject];

                objectSet({ QUESTION_USERS_LIST: newList });
                setDisplayModal(false);
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };
    const handleSearchData = (event) => {
        setSearchString(event);
        let temp_arr = dataset.filter((item) =>
            item.FULL_NAME.toLowerCase().includes(event.toLowerCase())
        );
        setFilteredData(temp_arr);
    };
    useEffect(() => {
        setFilteredData(dataset);

    }, [dataset]);
    
    return (
        <>
        {displayModal == true ?
            <div className={[MainStyle.modal].join(" ")}>
              <div className={[MainStyle.modal_dialog].join(" ")}>
                <div className={[MainStyle.modal_content, MainStyle.rounded_3, MainStyle.shadow_sm, MainStyle.border, MainStyle.bg_card, MainStyle.mx_3].join(" ")}>
                  <div className={MainStyle.m_3}>
                    <div className={MainStyle.modal_header}>
                      <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_4, MainStyle.fw_semibold].join(" ")}>
                        {GetLabel(appLang, 219)}
                      </span>
                    </div>
                    <div className={MainStyle.modal_body}>
                        <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_12}>
                                    <InputGeneral 
                                        value={searchString}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => handleSearchData(event.target.value)}
                                        placeholder={GetLabel(appLang, 33)}
                                        maxLength={500}
                                    />
                                </div>
                        </div>



                        <div className={[MainStyle.overflow_y_scroll].join(" ")} style={{height: '20rem'}}>

                        
                        {  filteredData !== dataset ?
                            
                            filteredData.length == 0 ?
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg_12}>
                                        <p className={[  MainStyle.fs_7,
                                                         MainStyle.text_body_faded,
                                                         MainStyle.fw_semibold,
                                                         MainStyle.mt_3,
                                                         MainStyle.text_center
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 220)}
                                        </p>
                                    </div>
                                </div>
                            :
                            filteredData.map((data) => {
                                return (
                                    <div key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                         onClick={() => handleSelect(data.USER_ID, 
                                                                     data.FULL_NAME, 
                                                                     data.COMPANY_POSITION_DESC,
                                                                     data.SECTOR_DESC,
                                                                     data.FILE_DATA)}
                                         alt={data.FULL_NAME}
                                    >
                                            <div className={MainStyle.col_12}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow, 
                                                                     MainStyle.rounded_circle,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        {
                                                            data.FILE_DATA != null ?
                                                                <img  src={getImgSrc(data.FILE_DATA)} 
                                                                      style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                                />
                                                            :
                                                                <Avatar/>
                                                        }
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3, MainStyle.mx_3].join(" ")}>
                                                        {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                                    </p>
                                                </div>
                                            </div>
                                    </div>
                                );
                            })
                        :
                            dataset.length > 0 ?                             
                            dataset.map((data) => {
                                return (
                                    <div key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                        onClick={() => handleSelect(data.USER_ID, 
                                                                    data.FULL_NAME, 
                                                                    data.COMPANY_POSITION_DESC,
                                                                    data.SECTOR_DESC,
                                                                    data.FILE_DATA)}
                                         alt={data.FULL_NAME}
                                    >
                                            <div className={MainStyle.col_12}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow, 
                                                                     MainStyle.rounded_circle,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        {
                                                            data.FILE_DATA != null ?
                                                                <img  src={getImgSrc(data.FILE_DATA)} 
                                                                      style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                                />
                                                            :
                                                                <Avatar/>
                                                        }
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3, MainStyle.text_start, MainStyle.mx_3].join(" ")}>
                                                        {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                                    </p>
                                                </div>
                                            </div>
                                    </div>
                                );
                            })
                            :
                            null
                        }
                        </div>
                    </div>
                    <div className={MainStyle.my_3}></div>
                    <div className={MainStyle.row}>
                      <div className={MainStyle.col_lg_7}></div>
                      <div className={MainStyle.col_lg_2}></div>
                      <div className={MainStyle.col_lg_1}></div>
                      <div className={MainStyle.col_lg_2}>
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                              style={{width: '100%'}}
                              className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_6, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                              onClick={() => setDisplayModal(false)}
                            >
                              {GetLabel(appLang, 53)}
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        :
        null
        }
        </>
    );

};
const UserHasAccess = ({itemId, objectSet, dataset}) => {
    const { showLoader,  hideLoader     }  = useLoader();         // Control over the loader
    const { showInfoMessage             }  = useInfoMsgModal();   // Modal message control     
    const { showToastMessage            }  = useToastMessage();   // Toast message display

    const handleDelete = async (user_id) => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await removeQuestionUser(itemId, user_id);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 221)});
                
                //  Handle the object state
                const newList = dataset.filter(user => user.USER_ID !== user_id);
                objectSet({ QUESTION_USERS_LIST: newList });
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    useEffect(() => {
    }, [ dataset ]);
    
    return (
        <>
            <div className={dataset.length > 0 ? MainStyle.overflow_y_scroll : null}
                 style={dataset.length > 0 ? {height: '20rem'}: null}
            >
                {
                    dataset.map((data) => {
                        return (
                            <div  key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom].join(" ")}>
                                    <div className={MainStyle.col_1}/>
                                    <div className={MainStyle.col_10}>
                                        <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                            <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                className={[MainStyle.border,
                                                            MainStyle.shadow, 
                                                            MainStyle.rounded_circle,
                                                            MainStyle.my_2].join(" ")}
                                            >
                                                {   
                                                    data.FILE_DATA != null ?
                                                        <img 
                                                            src={getImgSrc(data.FILE_DATA)} 
                                                            style={{width: '100%', height: '100%', objectFit:'cover', objectPosition: 'center'}}
                                                        />
                                                    :
                                                        <Avatar/>
                                                }
                                            </div>
                                            <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>
                                            {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                            </p>
                                            <div 
                                                className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1].join(" ")}
                                                onClick={() => {handleDelete(data.USER_ID)}}                                                 
                                            >
                                                <svg 
                                                    xmlns="http://www.w3.org/2000/svg" 
                                                    viewBox="0 0 448 512"
                                                    className={[MainStyle.small_ico_generic].join(" ")}
                                                >
                                                    <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.col_1}/>
                            </div>
                        );
                    })
                }                        
            </div>
        </>
    );

};
const QuestionPermissonPanel = ({ setProps, data }) => {
    const { showLoader,       hideLoader              }  = useLoader();                         // Control over the loader
    const { showInfoMessage                           }  = useInfoMsgModal();                   // Modal message control 
    const { showActionMessage                         }  = useActionModal();                    // Modal message + action control     
    const { showToastMessage                          }  = useToastMessage();                   // Toast message display
    const [ questionUserObj,   setQuestionUserObj     ]  = useState(blank_question_users_obj);  // Default object
    const [ displayModal,     setDisplayModal         ]  = useState(false);

    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_question_obj });
    };
    
    const handleChange = (updatedValues) => {
        const mergedValues = {
            ...questionUserObj,
            ...updatedValues
        };
        setQuestionUserObj(mergedValues);
    };

    useEffect(() => {
        const fetchData = async (pattern_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getQuestionUsers(pattern_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            setQuestionUserObj(fetchedData);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setQuestionUserObj(blank_question_users_obj);
            }
        };
        if (data?.QUESTION_ID && data.QUESTION_ID !== 0) {
            fetchData(data.QUESTION_ID);
        }
    }, [data]);

    return(
        <>
            <SelectDataPopup 
                            displayModal={displayModal}                 
                            setDisplayModal={setDisplayModal} 
                            objectSet={handleChange} 
                            mainDataset={questionUserObj}
                            dataset={questionUserObj.USERS_LIST}
            />
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={handleExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_3}/>
                    
                    {/*             Main Label              */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <span className={[MainStyle.fs_5,MainStyle.text_body,MainStyle.fw_semibold].join(" ")}>
                                {GetLabel(appLang, 222)}: {questionUserObj.QUESTION_DESC}
                            </span>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>                    
                    
                    <DefaultPadding/>
                    {/*     Label item list + btn add more  */}
                    <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_8}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                    MainStyle.text_body,
                                                    MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 180)}:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_2}>
                            <div className={MainStyle.mx_3}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_blue, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_7,
                                                MainStyle.text_white,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {setDisplayModal(true);}}
                                >
                                    {GetLabel(appLang, 223)}
                                </button>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    <DefaultPadding/>                    
                    {/*     List of users that has access  */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <UserHasAccess objectSet={handleChange} itemId={questionUserObj.QUESTION_ID} dataset={questionUserObj.QUESTION_USERS_LIST}/>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>


                    <DefaultPadding/>
                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
        </>
    );

};

const QuestionTableGrid = React.memo(({...other}) => {
    const { setProps,
            searchParam,
            setSearchParam,
            questionTypeList,
            rowData,
            setRowData                  }        = other;
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showFilter, hideFilter}              = useFilter();       // Control over the loader

    ModuleRegistry.registerModules([AllCommunityModule]);

    const availableIcon = (params) => {
        return (        
            <>
                <div 
                    className={[ MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    {
                        params.value == "Y" ?
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                viewBox="0 0 448 512"
                                className={[MainStyle.ico_checked].join(" ")}
                            >
                                <defs>
                                    <linearGradient id="checkmarkGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                        <stop offset="0%"    stopColor="rgba(48, 255, 158)" />
                                        <stop offset="80%"   stopColor="rgba(16, 90, 56)" />
                                    </linearGradient>
                                </defs>
                                <path 
                                    d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
                                    fill="url(#checkmarkGradient)"
                                />
                            </svg>
                        :
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                viewBox="0 0 384 512"
                                className={[MainStyle.ico_checked].join(" ")}
                            >
                                <defs>
                                    <linearGradient id="xmarkGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                        <stop offset="0%"    stopColor="rgba(220, 53, 69)" />
                                        <stop offset="80%"   stopColor="rgba(160, 39, 51)" />
                                    </linearGradient>
                                </defs>
                                <path 
                                    d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                                    fill="url(#xmarkGradient)"
                                />
                            </svg>
                    }
                </div>
            </>
        );
    };

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            hideFilter();
            let obj_copy = JSON.parse(JSON.stringify(blank_question_obj));
            obj_copy.QUESTION_ID = props.data.QUESTION_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const EditItemPermission = (props) => {
        const handleData = () => {
            hideFilter();
            let obj_copy = JSON.parse(JSON.stringify(blank_question_obj));
            obj_copy.QUESTION_ID = props.data.QUESTION_ID;
            setProps({ setScreen: 3, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 640 640" 
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"/>
                    </svg>
                </div>
            </>             
        );
    };

    const defaultCol = [
        DavidCopperfield(9,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        DavidCopperfield(9,89,4) && {
            headerName: GetLabel(appLang, 224),
            field: 'permissão',
            cellRenderer: EditItemPermission,
            cellClass: [MainStyle.table_text_center].join(" "), 
            headerClass: MainStyle.table_header_center,
            flex: 0,
        },
        { headerName: GetLabel(appLang, 34),   field: "QUESTION_ID"        ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" ")}    ,
        { headerName: GetLabel(appLang, 249),  field: "QUESTION_DESC"      ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
        { headerName: GetLabel(appLang, 234),  field: "QUESTION_TYPE_DESC" ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
        { headerName: GetLabel(appLang, 204),  field: "LANG_PT"            ,filter: false, autoHeight: true, flex: 0, cellRenderer: availableIcon, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "), }    ,
        { headerName: GetLabel(appLang, 205),  field: "LANG_EN"            ,filter: false, autoHeight: true, flex: 0, cellRenderer: availableIcon, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "), }    ,
        { headerName: GetLabel(appLang, 206),  field: "LANG_ES"            ,filter: false, autoHeight: true, flex: 0, cellRenderer: availableIcon, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "), }    ,
        { headerName: GetLabel(appLang, 117),  field: "CREATED"            ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
        { headerName: GetLabel(appLang, 118),  field: "UPDATED"            ,filter: true , flex: 1, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        if (searchParam) {
            setcolumnDefs(defaultCol);
            showFilter({jsx: 
                            <FilterOptions 
                                setRowData={setRowData}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                questionTypeList={questionTypeList}
                            />
            });
        }        
    },[searchParam, questionTypeList, rowData]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
        </>
    );
});

export const QuestionPage = () => {
    const [ screenType,         setScreenType       ]   = useState(1);
    const [ defaultData,        setDefaultData      ]   = useState({});
    const [ questionTypeList,   setQuestionTypeList ]   = useState(null);
    const { showInfoMessage                         }   = useInfoMsgModal();
    const navigate                                      = useNavigate();
    const [ searchParam, setSearchParam             ]   = useState(blank_search_param_obj);
    const [ rowData,     setRowData                 ]   = useState([]);
    const { showLoader, hideLoader                  }   = useLoader();
    const { showFilter, hideFilter                  }   = useFilter();

    useEffect(() => {
        const fetchQuestionData = async () => {
            let data = await getQuestionTypes();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setQuestionTypeList(data);
                }
                else {
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        };
        const fetchGridData = async () => {
            showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
            let data = await getQuestionLists(searchParam);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    let arr = [];
                    for(var j = 0; j < data.length; j++) {
                        arr.push(data[j]);
                    }
                    setRowData(arr);
                    hideLoader();
                }
                else {
                    hideLoader();
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        };
        fetchQuestionData();
        fetchGridData();
    },[]);

    const BtnNew = () => {
        hideFilter();
        handleChange({ setScreen: 2,data: blank_question_obj });
    };

    const handleChange = ({ setScreen, data }) => {
        setDefaultData({ ...data });
        setScreenType(setScreen);
    };

    useEffect(() => {
        if (!Heimdall([9])) {
            navigate('/home');
        }
        else {
            SetLastFeature(9);
        }        
    }, [screenType, defaultData]);

    return (
        <>
        {
        screenType == 1? 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 250)}
                </p>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_10}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(9,89,0) && (
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_blue, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={BtnNew}
                            >
                                {GetLabel(appLang, 120)}
                            </button>
                        </div>
                    )}
                </div>
            </div>            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_12}>
                    <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                        <QuestionTableGrid 
                            rowData={rowData} 
                            setRowData={setRowData} 
                            setProps={handleChange}
                            searchParam={searchParam}
                            setSearchParam={setSearchParam}
                            questionTypeList={questionTypeList}
                        />
                    </div>
                </div>
            </div>
            <div className={MainStyle.pb_3}></div>
        </>
        : screenType == 2 ?
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 251)}
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                <QuestionEditPanel setProps={handleChange} data={defaultData} typeList={questionTypeList} />
            </div>
        </>
        : screenType == 3 ?
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 252)}
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                <QuestionPermissonPanel setProps={handleChange} data={defaultData} />
            </div>
        </>
        : null
        }
        </>
    );
};